import type { Dispatch, SetStateAction } from 'react';
import { useMemo, useState } from 'react';

export type Pagination = {
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  totalPages: number;
};

export const DefaultPagination: Pagination = {
  page: 1,
  setPage: () => {},
  totalPages: 1
};

export function usePagination(totalPages: number, defaultPage?: number) {
  const [page, setPage] = useState<number>(defaultPage ?? 1);

  return useMemo<Pagination>(
    () => ({
      page,
      setPage,
      totalPages
    }),
    [page, setPage, totalPages]
  );
}
